import React from "react";
import styled from "styled-components";

import { RightArrow } from "../images/Icons";
import { capitalize, formatKoboBalance } from "../../../../../../utils/utilityFunctions";

const ProductCard = ({ cardItem, gap = "16px", icon, handleClick }) => {
    return (
        <ProductCardStyled gapStyled={gap} onClick={handleClick}>
            <div>{icon}</div>
            <div className="catalogue__content-wrap">
                <div>
                    <h4>{capitalize(cardItem.name)}</h4>
                    {cardItem?.unitPrice && <p>{formatKoboBalance(cardItem?.unitPrice)}</p>}
                </div>
                <div>
                    <RightArrow />
                </div>
            </div>
        </ProductCardStyled>
    );
};

export const ProductCardStyled = styled.div`
    border-radius: 5px;
    border: 1px solid #f4f4f4;
    background: #fff;
    box-shadow: 0px 0px 25px 0px rgba(0, 0, 0, 0.06);
    padding: 20px 16px 20px 20px;
    display: flex;
    flex-direction: column;
    gap: ${({ gapStyled }) => gapStyled};
    cursor: pointer;
    .catalogue__content-wrap {
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
        h4 {
            color: #000;
            font-size: 1.063rem;
            font-weight: 900;
            line-height: 20px;
        }
        p {
            color: #979797;
            margin-top: 4px;
        }
    }
`;
export default ProductCard;
